import {record, string} from '@cindedi/validation';
import {email} from '@cindedi/validation/rules/email';

export const PublicUserDto = record<Account.PublicUserDto>({
  name: string(),
  email: string(email()),
});
